import './App.css';
import { AuthProvider } from './context/AuthContext';
import RouterMain from './components/RouterMain';


function App() {
  return (
    <AuthProvider>
      <RouterMain />
      
    </AuthProvider>
   
  );
}

export default App;
